import styled from 'styled-components';

export const ListContainer = styled.div`
	height: 290px;
	overflow-y: auto;
	&.show-all {
		height: 346px;
	}
`;
